import { Link } from "react-router-dom";
import ThomLogo from "@/components/ThomLogo";

const Footer = () => (
  <footer className="mt-24 border-t border-border bg-[#0A0A0A] text-white/80" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-6 py-14 grid md:grid-cols-[1.4fr_auto_auto_auto] gap-12 items-start">
      <div className="max-w-[560px]">
        <ThomLogo size={40} variant="onDark" showTagline />
        <p className="mt-6 text-[12.5px] leading-[1.75] text-white/65" data-testid="footer-positioning">
          THOM Verify™ is Africa's Independent Verification and Transaction Assurance Company,
          providing independent verification, evidence collection, due diligence and documented
          findings that help individuals, businesses, financial institutions and governments
          make informed decisions across Africa.
        </p>
      </div>
      <FooterCol title="Platform">
        <FooterLink to="/services">All Services</FooterLink>
        <FooterLink to="/marketplace">Verified Vehicles</FooterLink>
        <FooterLink to="/property">Verified Property</FooterLink>
        <FooterLink to="/find-my-vehicle">Find My Vehicle</FooterLink>
        <FooterLink to="/advisor">Buyer Advisor</FooterLink>
        <FooterLink to="/network">Trust Network</FooterLink>
      </FooterCol>
      <FooterCol title="Trust">
        <FooterLink to="/verify">Verify a Certificate</FooterLink>
        <FooterLink to="/passport/vehicle/">Digital Asset Passport</FooterLink>
        <FooterLink to="/network">Verified Organisations</FooterLink>
      </FooterCol>
      <FooterCol title="Enterprise">
        <FooterLink to="/register">Become a partner</FooterLink>
        <FooterLink to="/network/register">Register organisation</FooterLink>
        <FooterLink to="/login">Sign in</FooterLink>
      </FooterCol>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 py-6 text-[11.5px] text-white/55 leading-[1.75] max-w-[900px]" data-testid="footer-service-philosophy">
        <b className="text-white/80">Service Philosophy.</b>{" "}
        THOM Verify complements — not replaces — the roles of statutory authorities, regulators,
        law enforcement agencies, legal advisers, insurers, engineers acting in a certification
        capacity and other professionals whose approvals, certifications or decisions are required
        by law.
      </div>
      <div className="max-w-[1400px] mx-auto px-6 pb-6 text-[11px] text-white/45 leading-[1.75] max-w-[900px]" data-testid="footer-verification-scope">
        THOM Verify™ provides independent findings based on information available at the time of
        verification and applicable data sources. Where authorised data is available, verification
        may include ownership, identity, theft status, finance interests, VIN and engine
        authentication, tampering indicators, customs and registration history, accident history,
        inspection findings and other relevant risk assessments. Final regulatory decisions remain
        the responsibility of the appropriate authorities.
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[11px] text-white/50">
        <div>© {new Date().getFullYear()} THOM Verify™ · Africa's Independent Verification and Transaction Assurance Company.</div>
        <div className="mono uppercase tracking-widest">Securing Assets · Building Trust · Across Africa</div>
      </div>
    </div>
  </footer>
);

const FooterCol = ({ title, children }) => (
  <div>
    <div className="mono text-[10px] uppercase tracking-widest text-white/40 mb-3">{title}</div>
    <ul className="space-y-2">{children}</ul>
  </div>
);

const FooterLink = ({ to, children }) => (
  <li><Link to={to} className="text-[13px] hover:text-primary transition-colors">{children}</Link></li>
);

export default Footer;
